import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Col, Row, Spinner } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CategoryAdd = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        categoryid: '',
        categoryname: '',
        categorydisplayname: '',
        categorydetails: '',
        isactive: 1 // Default to active
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Clean up the URL to ensure it's formatted correctly
    const rawBaseUrl = process.env.REACT_APP_API_URL ;
    const url = rawBaseUrl.endsWith('/') ? rawBaseUrl : `${rawBaseUrl}/`;

    const handleChange = (e) => {
        const { id, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            // Convert checkbox boolean to 1 or 0 for MySQL
            [id]: type === 'checkbox' ? (checked ? 1 : 0) : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.categoryid || !formData.categoryname.trim() || !formData.categorydisplayname.trim()) {
            toast.error("Please fill in all required fields.", { theme: "colored" });
            return;
        }
         setIsSubmitting(true);
            try {
                 const token = localStorage.getItem('jwttoken');
                 const headers = { 'x-access-token': token };

                 const postData = {
                    categoryid: formData.categoryid, 
                    categoryname: formData.categoryname.trim(),
                    categorydisplayname: formData.categorydisplayname.trim(),
                    categorydetails: formData.categorydetails.trim(),
                    isactive: formData.isactive 
                };

                const response = await axios.post(`${url}postcategory/addNewData`, postData, { headers });
                
                if (response.status === 201 || response.status === 200) {
                toast.success("Category created successfully!", {
                    position: "top-right",
                    autoClose: 1500,
                    theme: "colored"
                });
                    setTimeout(() => navigate('/categorylist'), 1500);
                } 
            } catch (err) {
                const errorMsg = err.response?.data?.message || err.response?.data?.err || "Failed to create category.";
            toast.error(errorMsg, { 
                position: "top-right",
                theme: "colored" 
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="form-card">
                <div className="form-card-header">Add New Category</div>
                <div className="form-card-body">
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="categoryid">
                                <Form.Label>Category ID:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. 99"
                                    value={formData.categoryid}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                            </Form.Group>

                            <Form.Group as={Col} controlId="categoryname">
                                <Form.Label>Category Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. MERN"
                                    value={formData.categoryname}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="categorydisplayname">
                                <Form.Label>Display Name:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g. MERN STACK"
                                    value={formData.categorydisplayname}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                            </Form.Group>

                            <Form.Group as={Col} controlId="isactive">
                                <Form.Label>Status:</Form.Label>
                                <div className="toggle-switch mt-2">
                                    <input
                                        type="checkbox"
                                        id="isactive"
                                        checked={formData.isactive === 1}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                    <span className="toggle-switch-label">Visible on Website</span>
                                </div>
                            </Form.Group>
                        </Row>

                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="categorydetails">
                                <Form.Label>Category Details:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter details..."
                                    value={formData.categorydetails}
                                    onChange={handleChange}
                                    disabled={isSubmitting}
                                />
                            </Form.Group>
                        </Row>

                        <div className="form-actions">
                            <button 
                                type="submit" 
                                className="btn-gradient-success" 
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <><Spinner animation="border" size="sm" /> Creating...</>
                                ) : "Create Category"}
                            </button>
                            <Link to="/categorylist" className="btn-back-link" style={{ marginLeft: '15px', textDecoration: 'none' }}>
                                ← Back to List
                            </Link>
                        </div>
                    </Form>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default CategoryAdd;
